module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-ranger-picker"
  }, [_c('VueCtkRangeDatePicker', {
    attrs: {
      "range": true,
      "label": _vm.label,
      "noLabel": true,
      "noHeader": false,
      "color": _vm.color,
      "format": _vm.format,
      "formatted": 'll',
      "value": _vm.value
    },
    on: {
      "input": _vm.dateRangeSelected
    },
    model: {
      value: (_vm.myRange),
      callback: function($$v) {
        _vm.myRange = $$v
      },
      expression: "myRange"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3ac5468!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/DateRangePicker.vue
// module id = 2526
// module chunks = 1